var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingBagFilled = function SvgShoppingBagFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.098 5.01a5.002 5.002 0 0 1 9.804 0q.333.007.618.03c.522.04 1.003.128 1.463.346a4 4 0 0 1 1.723 1.569c.26.437.392.908.482 1.425.086.495.143 1.104.212 1.84l.608 6.482c.081.873.149 1.59.154 2.176.006.605-.052 1.167-.281 1.701a4 4 0 0 1-1.76 1.933c-.51.278-1.064.388-1.668.439-.583.049-1.304.049-2.18.049H7.727c-.877 0-1.598 0-2.181-.05-.604-.05-1.158-.16-1.668-.438a4 4 0 0 1-1.76-1.933c-.23-.534-.287-1.096-.281-1.701.005-.585.072-1.303.154-2.176L2.6 10.22c.069-.736.126-1.345.212-1.84.09-.517.222-.988.482-1.425a4 4 0 0 1 1.722-1.569c.46-.218.942-.306 1.464-.347q.285-.022.618-.03M9.171 5a3.001 3.001 0 0 1 5.658 0z",
    clipRule: "evenodd"
  })));
};
export default SvgShoppingBagFilled;